import React, { useState, useEffect } from 'react';
import { TextField, Box, Grid, Button, Typography, CircularProgress } from '@mui/material';
import ValidationFunctions from '../../utils/ValidationFunctions';
import { useSelector, useDispatch } from 'react-redux';
import * as registerActions from '../../core/Store/Actions/RegisterActions';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/loader';
import { useSnackbar } from 'notistack';
import { AiOutlineLeft } from "react-icons/ai";
import './styles.css'
import ButtonComponent from '../../components/loaderNew';

const TwoAuthVerify = () => {
    const usernameData = useSelector(state => state.registerReducer.userData);
    const userData = useSelector(state => state.registerReducer.userVerifyData);
    const loading = useSelector(state => state.registerReducer.loading);
    const validData = useSelector(state => state.registerReducer.validData);
    const verifyUserData = useSelector(state => state.registerReducer.verifyData);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    //const { enqueueSnackbar } = useSnackbar();

    const { username } = usernameData && usernameData;
    const [verifyCode, setVerifyCode] = useState('');
    const [validCode, setValidCode] = useState(false);
    const [verifyType] = useState(
        username.trim().length == 0 ||
            isNaN(
                username
                    .trim()
                    .replace('(', '')
                    .replace(')', '')
                    .replace('-', '')
                    .replace(' ', ''),
            )
            ? 'email'
            : 'sms',
    );

    useEffect(() => {
        if (userData && userData.token) {
            localStorage.setItem('token', userData.token);
            navigate('/room/patient');
        }
    }, [userData]);
    useEffect(() => {
        console.log("Verify user data",verifyUserData);
        if (verifyUserData && verifyUserData.register) {
            localStorage.setItem('registertoken', verifyUserData.register);
            navigate('/room/register');
        }
    }, [verifyUserData]);

    useEffect(() => {
        if (validData && validData.doc_id) {
            //enqueueSnackbar('Verification code sent successfully', { variant: "success" })
            dispatch(registerActions.validateUserResponse({}));
        }
    }, [validData]);
    const onTextChange = (text) => {
        const textValue = text.target.value;
        if (textValue)
            setVerifyCode(textValue);
        else {
            setVerifyCode(textValue);
            setValidCode(false);
            // setValidMobile(false);
        }
    }
    const onVerifyCode = () => {
        if (!verifyCode) {
            return;
        }
        let errOnCode = ValidationFunctions.check2FACodeValid(
            verifyCode.trim(),
        );
        if (errOnCode) {
            setValidCode(true);
            return;
        }
        setValidCode(false);
        // const payload = {
        //     code: verifyCode,
        //     email: usernameData && username || ''
        // }
        const payload = {
            verificationCode: parseInt(verifyCode),
            username: verifyType === 'sms' ? username && username.replace(/[^0-9]/g, '') : username
        }
        dispatch(registerActions.verify2faCodeRequest(payload));
    }
    const onResendcode = () => {
        if (usernameData)
            dispatch(registerActions.validateUserRequest(usernameData));
    }
    const onBack = (e) => {
        //e.preventDefault();
        navigate('/');
        dispatch(registerActions.validateUserResponse({}));
    }
    return (

        <Grid>
            <Grid className='App'>
                <Grid style={{ height: "100vh", padding: '10%' }}>
                    <div style={{
                        width: "100%",
                        backgroundColor: "white",
                        //height: "100%",
                        display: "flex",
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }}>
                        <Typography variant="h1" style={{
                            textAlign: "left",
                            fontFamily: 'Manrope',
                            fontStyle: 'normal',
                            fontWeight: 600,
                            fontSize: 28,
                            display: "flex",
                            justifyContent: "space-between",
                            color: "#000000",
                        }} >Verify your identity
                        </Typography>
                        <Button className='titleText' style={{
                            fontFamily: 'Manrope',
                            fontStyle: "normal",
                            fontWeight: 600,
                            fontSize: 24,
                            display: "flex",
                            alignItems: "center",
                            color: "#024C9C",
                            textDecoration: "none",
                        }} onClick={onBack}>
                            <AiOutlineLeft />Back</Button>
                    </div>
                    <Box style={{
                        flexDirection: 'column',
                        marginBottom: 20,
                        width: '100%',
                        height: 'auto',
                        padding: '5% 0% 3% 0%',
                    }}>
                        {/* <h1>Verify your identity</h1> */}
                        <Typography style={{
                            textAlign: 'left',
                            fontSize: '18px',
                            fontFamily: 'manrope',
                            fontStyle: 'normal',
                            fontWeight: '400',
                            marginBottom: '1%', color: '#565656',
                        }}>{`For your security, we need to verify your identity before we let you check in. For this, we just sent you a temporary verification code to`}</Typography>
                        <Typography style={{
                            textAlign: 'left',
                            fontSize: '18px',
                            fontFamily: 'manrope',
                            fontStyle: 'normal',
                            fontWeight: '400',
                            marginBottom: '1%', color: '#565656'
                        }}> <strong>{usernameData && username}</strong></Typography>
                        <Typography style={{
                            textAlign: 'left',
                            fontSize: '18px',
                            fontFamily: 'manrope',
                            fontStyle: 'normal',
                            fontWeight: '400',
                            marginBottom: '1%', color: '#565656'
                        }}>{`Once you receive the code, enter it in the box provided below:`}</Typography>
                    </Box>
                    <Grid style={{
                        marginBottom: 20,
                        alignSelf: 'flex-start',
                        alignContent: 'flex-start',
                        justifyContent: 'flex-start',
                        width: '100%'
                    }}>
                        <TextField style={{
                            width: '50%',
                            //height: '79px',
                            backgroundColor: ' #F2F2F2',
                            borderRadius: '5px',
                            marginRight: 10,
                        }}
                            onChange={(text) => {
                                onTextChange(text)
                            }}
                            value={verifyCode}
                            placeholder={'Verification Code'}
                            disabled={loading}
                        />
                        {/* <ButtonComponent style={{ width: '30%', backgroundColor: '#024C9C', fontSize: 18, fontFamily: 'Manrope', alignSelf: 'center', marginTop: 5 }} loading={!(verifyCode && verifyCode.length > 5 && verifyCode.length < 7) ||loading} title='Verify' onClick={onVerifyCode}  /> */}
                        <Button disabled={!(verifyCode && verifyCode.length > 5 && verifyCode.length < 7) || loading} style={{ width: '30%', backgroundColor: '#024C9C', fontSize: 18, fontFamily: 'Manrope', alignSelf: 'center', marginTop: 5,borderRadius:'10px'  }} variant="contained" onClick={onVerifyCode} >
                            {loading && <CircularProgress style={{ margin: '5%' }} style={{color:'#ffffff'}} size={20} />}
                            {!loading && 'Verify'}
                        </Button>
                        {validCode && <Typography style={{ color: 'red', fontSize: 14 }}>Please enter valid verification code</Typography>}
                        {/* {validMobile && <Typography style={{ color: 'red', fontSize: 14 }}>Please enter valid mobile number</Typography>} */}
                    </Grid>
                    <Grid style={{ flexDirection: 'row' }}>
                        <Typography style={{
                            textAlign: 'left',
                            fontSize: '18px',
                            fontFamily: 'manrope',
                            fontStyle: 'normal',
                            fontWeight: '400',
                            marginBottom: '1%', color: '#565656'
                        }}>Didn't receive the code or the code didn't work?<Button disabled={loading} style={{ textDecoration: 'underline',fontSize: '18px',
                        fontFamily: 'manrope',
                        fontStyle: 'normal',
                        fontWeight: '400',color: "#024C9C", }} onClick={onResendcode}>Resend Code</Button></Typography>
                    </Grid>
                    {/* <Button style={{ width: '10%' }} variant="contained" onClick={onBack} disabled={loading} >Back</Button> */}
                    {/* <Typography>{username}</Typography> */}
                </Grid>
            </Grid>
            {/* {loading && <Loader />} */}
        </Grid>
    );
}

export default TwoAuthVerify;